<template>
  <v-navigation-drawer
    close-on-click
    v-if="['xs', 'sm'].includes($size)"
    right
    :value="value"
    @input="$emit('input', $event)"
    app
    width="100%"
    class="nav-drawer"
    hide-overlay
  >
    <v-list dense class="sidebar">
      <v-list-item link href="https://campusmoviefest.com/opportunities">
        <v-list-item-content>
          <v-list-item-title>Participate</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item link href="https://campusmoviefest.com/movies">
        <v-list-item-content>
          <v-list-item-title>Watch</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item link href="https://campusmoviefest.com/support">
        <v-list-item-content>
          <v-list-item-title>Support</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item link href="https://live.campusmoviefest.com">
        <v-list-item-content>
          <v-list-item-title>Premiere</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item link href="https://live.campusmoviefest.com/workshops">
        <v-list-item-content>
          <v-list-item-title>Workshops</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item link href="https://campusmoviefest.com/about">
        <v-list-item-content>
          <v-list-item-title>About</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item
        v-if="currentUser"
        link
        @click="
          $store.dispatch('auth/logout');
          $emit('input', !value);
        "
      >
        <v-list-item-content>
          <v-list-item-title>Logout</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
export default {
  name: "Sidebar",
  props: {
    value: Boolean
  }
};
</script>

<style scoped lang="scss">
.sidebar {
  ::v-deep .v-list-item__title {
    font-size: 16px;
    line-height: 1.6em;
  }

  .v-list-item__content {
    padding: 1em 0;
  }

  .v-list-item__title {
    font-family: $body-font-family, sans-serif;
    font-weight: 600;
    font-size: 36px;
    line-height: 1.167;
    color: white;
    letter-spacing: -0.02em;
  }
}

.theme--light.v-navigation-drawer.nav-drawer {
  top: 70px !important;
  background-color: $cmf-blue;
}

@media screen and (max-width: 375px) {
  .sidebar {
    .v-list-item__title {
      font-size: 9.6vw;
    }
  }
}
</style>
